export class StripeAccount {
  type: StripeType = "custom";
  email?: string = "";
  business_type: BusinessType = "individual";
  requested_capabilities: RequestedCapabilities[] = ["card_payments", "transfers"];
  business_profile?: BusinessProfile = new BusinessProfile();
  default_currency?: StripeCurrency = "USD";
  external_account: BankAccount | string; //StripeToken
  settings?: Settings = new Settings();
  tos_acceptance?: TOSAcceptance = new TOSAcceptance();
  account_token?: any;
  metadata?: object;
}

export class Settings {
  branding?: object;
  card_payments?: CardPayments = new CardPayments();
  payments?: Payments;
  payouts?: object;
}

export class CardPayments {
  decline_on: DeclineOn = new DeclineOn();
  statement_descriptor_prefix?: string;
}
export class Payments {
  statement_descriptor?: string;
}

export class Company {
  address: Address = new Address();
  directors_provided: boolean = false;
  executives_provided: boolean = false;
  name: string = "";
  owners_provided: boolean = false;
  phone: string = "";
  tax_id: string = "";
  verification?: CompanyVerification;
}

export class IndividualVerification {
  document?: IdentityDocument;
  additional_document?: IdentityDocument;
}
export class CompanyVerification {
  document?: IdentityDocument;
}

export class IdentityDocument {
  front: any;
  back: any;
}

export class BusinessProfile {
  mcc?: string = "8398"; //code for Charitable and Social Service Organizations - Fundraising - see https://stripe.com/docs/connect/setting-mcc
  name?: string;
  product_description?: string = "Crowdfunding";
  support_email?: string;
  support_phone?: string;
  support_url?: string;
  url?: string;
}

export class CardHolder {
  name: string = "";
  currency: StripeCurrency = "USD";
  address_line1?: string;
  address_line2?: string;
  address_city?: string;
  address_state?: string;
  address_zip?: string;
  address_country: CountryCode = "US";
}

export class StripeCardStatus {
  cardNumber: StripeEvent = new StripeEvent();
  cardExpiry: StripeEvent = new StripeEvent();
  cardCvc: StripeEvent = new StripeEvent();
  get valid() {
    try {
      return !this.cardNumber.error && !this.cardExpiry.error && !this.cardCvc.error;
    } catch (e) {
      return false;
    }
  }
}

export class StripeEvent {
  error: StripeError;
  empty: boolean = true;
  complete: boolean = false;
  value: undefined;
  brand?: string;
}

export class StripeError {
  code: string = "";
  type: string = "";
  message: string = "";
}

export class BankAccount {
  object?: "bank_account" = "bank_account";
  country: CountryCode = "US";
  currency: StripeCurrency = "USD";
  account_holder_name: string = "";
  account_holder_type: BusinessType = "individual";
  routing_number: string = "";
  account_number: string = "";
  verify_account_number: string = "";
}

export class AccountPerson {
  first_name: string = "";
  last_name: string = "";
  dob: DOB = new DOB();
  ssn_last_4: string = "";
  id_number?: string;
  address: Address = new Address();
  email: string = "";
  phone: string = "";
  metadata: StripePersonMetadata = new StripePersonMetadata();
  relationship: RepresentativeRelationship = new RepresentativeRelationship();
}

export class StripePersonMetadata {
  type: string = "individual";
}

export class RepresentativeRelationship {
  title: string = "";
  owner: boolean = false;
  executive: boolean = false;
  representative: boolean = true;
}
class Address {
  city?: string = "";
  line1?: string = "";
  line2?: string = "";
  country?: CountryCode = "US";
  postal_code?: string = "";
  state?: string = "";
  alt_state?: string = "";
  additional_info: string = "";
}

export class DOB {
  day: string;
  month: string;
  year: string;

  constructor(month = "", day = "", year = "") {
    this.month = month;
    this.day = day;
    this.year = year;
  }
}

class TOSAcceptance {
  date?: number = 0;
  ip?: string = "";
  user_agent?: string;
}

class DeclineOn {
  avs_failure?: boolean = true;
  cvc_failure?: boolean = true;
}

export type StripeType = "custom" | "standard" | "express";

export type BusinessType = "individual" | "company";
// | "non_profit"
// | "government_entity"

export type CountryCode =
  | "US"
  | "AU"
  | "AT"
  | "BE"
  | "CA"
  | "DK"
  | "FI"
  | "FR"
  | "DE"
  | "HK"
  | "IE"
  | "JP"
  | "LU"
  | "NL"
  | "NZ"
  | "NO"
  | "SG"
  | "ES"
  | "SE"
  | "CH"
  | "GB"
  | "";

export type StripeCurrency =
  | "AED"
  | "AFN"
  | "ALL"
  | "AMD"
  | "ANG"
  | "AOA"
  | "ARS"
  | "AUD"
  | "AWG"
  | "AZN"
  | "BAM"
  | "BBD"
  | "BDT"
  | "BGN"
  | "BHD"
  | "BIF"
  | "BMD"
  | "BND"
  | "BOB"
  | "BRL"
  | "BSD"
  | "BTC"
  | "BTN"
  | "BWP"
  | "BYN"
  | "BZD"
  | "CAD"
  | "CDF"
  | "CHF"
  | "CLF"
  | "CLP"
  | "CNH"
  | "CNY"
  | "COP"
  | "CRC"
  | "CUC"
  | "CUP"
  | "CVE"
  | "CZK"
  | "DJF"
  | "DKK"
  | "DOP"
  | "DZD"
  | "EGP"
  | "ERN"
  | "ETB"
  | "EUR"
  | "FJD"
  | "FKP"
  | "GBP"
  | "GEL"
  | "GGP"
  | "GHS"
  | "GIP"
  | "GMD"
  | "GNF"
  | "GTQ"
  | "GYD"
  | "HKD"
  | "HNL"
  | "HRK"
  | "HTG"
  | "HUF"
  | "IDR"
  | "ILS"
  | "IMP"
  | "INR"
  | "IQD"
  | "IRR"
  | "ISK"
  | "JEP"
  | "JMD"
  | "JOD"
  | "JPY"
  | "KES"
  | "KGS"
  | "KHR"
  | "KMF"
  | "KPW"
  | "KRW"
  | "KWD"
  | "KYD"
  | "KZT"
  | "LAK"
  | "LBP"
  | "LKR"
  | "LRD"
  | "LSL"
  | "LYD"
  | "MAD"
  | "MDL"
  | "MGA"
  | "MKD"
  | "MMK"
  | "MNT"
  | "MOP"
  | "MRO"
  | "MRU"
  | "MUR"
  | "MVR"
  | "MWK"
  | "MXN"
  | "MYR"
  | "MZN"
  | "NAD"
  | "NGN"
  | "NIO"
  | "NOK"
  | "NPR"
  | "NZD"
  | "OMR"
  | "PAB"
  | "PEN"
  | "PGK"
  | "PHP"
  | "PKR"
  | "PLN"
  | "PYG"
  | "QAR"
  | "RON"
  | "RSD"
  | "RUB"
  | "RWF"
  | "SAR"
  | "SBD"
  | "SCR"
  | "SDG"
  | "SEK"
  | "SGD"
  | "SHP"
  | "SLL"
  | "SOS"
  | "SRD"
  | "SSP"
  | "STD"
  | "STN"
  | "SVC"
  | "SYP"
  | "SZL"
  | "THB"
  | "TJS"
  | "TMT"
  | "TND"
  | "TOP"
  | "TRY"
  | "TTD"
  | "TWD"
  | "TZS"
  | "UAH"
  | "UGX"
  | "USD"
  | "UYU"
  | "UZS"
  | "VEF"
  | "VND"
  | "VUV"
  | "WST"
  | "XAF"
  | "XAG"
  | "XAU"
  | "XCD"
  | "XDR"
  | "XOF"
  | "XPD"
  | "XPF"
  | "XPT"
  | "YER"
  | "ZAR"
  | "ZMW"
  | "ZWL";

export type RequestedCapabilities = "card_payments" | "transfers" | "legacy_payments"; // removed from api after 02/20/2020

export type AccountPersonType = "individual" | "representative";

export type RepresentativeType = "owner" | "executive";

export type StripeElementType = "cardNumber" | "cardExpiry" | "cardCvc";



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./app/models/stripe-account.ts